import React from 'react';
import { Zap, Package } from 'lucide-react';

const ProductItem = ({ item }) => (
  <div className="flex justify-between pb-3 border-b dark:border-gray-700 last:border-0">
    <div>
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-full ${item.is_lightning_lot ? 'bg-amber-100 dark:bg-amber-900/50' : 'bg-green-100 dark:bg-green-900/50'}`}>
          {item.is_lightning_lot ? (
            <Zap className="w-4 h-4 text-amber-600 dark:text-amber-400" />
          ) : (
            <Package className="w-4 h-4 text-green-600 dark:text-green-400" />
          )}
        </div>
        <div className="font-medium text-gray-900 dark:text-white">{item.title}</div>
      </div>
      <div className="text-sm text-gray-500 dark:text-gray-400">
        {item.quantity} {item.unit} × ${(item.unitPrice || 0).toLocaleString()}
      </div>
      {item.deposit > 0 && (
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Seña: ${item.deposit} × {item.quantity} {item.unit}
        </div>
      )}
      <div className="text-xs text-gray-400 dark:text-gray-500 mt-1">
        {item.is_lightning_lot ? 'Venta relámpago' : `Lote #${item.lotId}`}
      </div>
    </div>
    <div className="text-right">
      <div className="text-gray-900 dark:text-white">${(item.subtotal || 0).toLocaleString()}</div>
      {item.totalDeposit > 0 && (
        <div className="text-sm text-gray-500 dark:text-gray-400">
          +${(item.totalDeposit || 0).toLocaleString()}
        </div>
      )}
    </div>
  </div>
);

const TotalSection = ({ totals }) => (
  <div className="mt-4 pt-4 border-t dark:border-gray-700 space-y-2">
    <div className="flex justify-between text-gray-500 dark:text-gray-400">
      <span>Subtotal</span>
      <span>${(totals.subtotal || 0).toLocaleString()}</span>
    </div>
    {totals.deposits > 0 && (
      <div className="flex justify-between text-gray-500 dark:text-gray-400">
        <span>Total señas</span>
        <span>${(totals.deposits || 0).toLocaleString()}</span>
      </div>
    )}
    <div className="flex justify-between font-bold text-gray-900 dark:text-white">
      <span>Total</span>
      <span>${(totals.total || 0).toLocaleString()}</span>
    </div>
  </div>
);

const ProductsList = ({ items, totals }) => (
  <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border dark:border-gray-700">
    <h2 className="font-medium text-gray-900 dark:text-white mb-3">Productos</h2>
    <div className="space-y-4">
      {items.map((item, index) => (
        <ProductItem key={index} item={item} />
      ))}
    </div>
    <TotalSection totals={totals} />
  </div>
);

export default ProductsList; 